import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { Invoice } from '../../models/invoice-details.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-user-details',
    imports: [CommonModule, MatCardModule, TranslatePipe],
    templateUrl: './user-details.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './user-details.component.scss'
})
export class UserDetailsComponent {
    @Input() invoice?: Invoice;
}
